import CasePage from './CasePage'

export default CasePage